import {
    SEARCH_TASKS_REQUEST,
    SEARCH_TASKS_SUCCESS,
    SEARCH_TASKS_FAILURE,
    FETCH_TASK_REQUEST,
    FETCH_TASK_SUCCESS,
    FETCH_TASK_FAILURE,
    CREATE_TASK_REQUEST,
    CREATE_TASK_SUCCESS,
    CREATE_TASK_FAILURE,
    UPDATE_TASK_REQUEST,
    UPDATE_TASK_SUCCESS,
    UPDATE_TASK_FAILURE,
    DELETE_TASK_REQUEST,
    DELETE_TASK_SUCCESS,
    DELETE_TASK_FAILURE,
    RESET_TASK_STATE
} from '../actions/task-actions';

const initialState = {
    tasks: {
        value: [],
        totalCount: 0,
        page: 0,
        size: 20,
        totalPages: 0
    },
    currentTask: null,
    loading: false,
    error: null,
    createSuccess: false,
    updateSuccess: false,
    deleteSuccess: false
};

const taskReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEARCH_TASKS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case SEARCH_TASKS_SUCCESS:
            return {
                ...state,
                loading: false,
                tasks: action.payload,
                error: null
            };
        case SEARCH_TASKS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        
        case FETCH_TASK_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_TASK_SUCCESS:
            return {
                ...state,
                loading: false,
                currentTask: action.payload,
                error: null
            };
        case FETCH_TASK_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        
        case CREATE_TASK_REQUEST:
            return {
                ...state,
                loading: true,
                createSuccess: false,
                error: null
            };
        case CREATE_TASK_SUCCESS:
            return {
                ...state,
                loading: false,
                createSuccess: true,
                currentTask: action.payload,
                error: null
            };
        case CREATE_TASK_FAILURE:
            return {
                ...state,
                loading: false,
                createSuccess: false,
                error: action.payload
            };
        
        case UPDATE_TASK_REQUEST:
            return {
                ...state,
                loading: true,
                updateSuccess: false,
                error: null
            };
        case UPDATE_TASK_SUCCESS:
            return {
                ...state,
                loading: false,
                updateSuccess: true,
                currentTask: action.payload,
                error: null
            };
        case UPDATE_TASK_FAILURE:
            return {
                ...state,
                loading: false,
                updateSuccess: false,
                error: action.payload
            };
        
        case DELETE_TASK_REQUEST:
            return {
                ...state,
                loading: true,
                deleteSuccess: false,
                error: null
            };
        case DELETE_TASK_SUCCESS:
            return {
                ...state,
                loading: false,
                deleteSuccess: true,
                tasks: {
                    ...state.tasks,
                    value: state.tasks.value.filter(task => task.id !== action.payload)
                },
                error: null
            };
        case DELETE_TASK_FAILURE:
            return {
                ...state,
                loading: false,
                deleteSuccess: false,
                error: action.payload
            };
        
        case RESET_TASK_STATE:
            return {
                ...state,
                createSuccess: false,
                updateSuccess: false,
                deleteSuccess: false,
                error: null
            };
        
        default:
            return state;
    }
};

export default taskReducer;
